import React, { useState,useEffect } from "react";
// import Header from "../header/header";
import FamilyImg from "../../assets/img/familyStories.png";
import Navbar from '../layouts/navbar';
import Parse from 'parse';
import swal from "sweetalert";
import "./familystories.css";
import {Link} from 'react-router-dom';


const SingleFamilyStory =(props) =>  {

  const [story, setStory] = useState('');
  const [youtube, setYoutube] = useState('');

  useEffect(() => {
    console.log("useEffect running");
    console.log(props.match.params.id);
    const id = props.match.params.id;
    console.log(typeof props.match.params.id)


    const FamilyStories = Parse.Object.extend("FamilyStories");
    const query = new Parse.Query(FamilyStories);
    // const familyStories = new FamilyStories();
    query.get(id)
    .then((story) => {

      console.log(story.get("story"))
      setStory(story.get("story"));
      setYoutube(story.get("youtube"));

    },(error) => {
      console.log(error);
      swal("Oops!", "Seems like there is some problem with net", "error");

    })




  },[])



    return (
      <div>
        <Navbar head="family story" />
        
        {/* <Header header='Stories' /> */}

        {/* carousels */}
       
        <div className='container' style={{marginTop:"50px"}}>
        <div className="row">
          <div className="col-12 text-center">
          <img  className="img-fluid" src={FamilyImg} alt="" />
          </div>
        </div>
        
        
        <div className="px-md-5 mx-md-5">

        <h3 >Family </h3>
        <span className="lead">
          <i class="fab fa-youtube fa-lg"></i> Youtube Link</span>
        <br/>

          <p className="mt-3">
            
            {story}
          </p>
        </div>
  
        <Link to="/familystories/addstory">
        <button type="button" className="  story">
          <i className="fas fa-plus plus"></i> Add Your Story
        </button>
        </Link>
      
    
    
      </div>
      </div>
    );
  }

export default SingleFamilyStory;
